











import VueOptions from '@utils/VueOptions'
import VendorListingCard from '@ui/cards/VendorListingCard'

settings =
  name: 'VendorListingsCardView'

  vue:
    props: ['items', 'activationPlans', 'actions']

    components: {
      VendorListingCard,
    }

export default VueOptions.vue settings
